import { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import useQueryParams from '@polyai/common/hooks/useQueryParams';
import { Loader } from '@polyai/ui/components/atoms/Loader';

import { LOGOUT_REDIRECT_URLS } from './constants';

const Logout = () => {
  const { logout } = useAuth0();
  const searchParams = useQueryParams();
  const redirectKey = searchParams.get('redirect');
  const redirectUrl =
    (redirectKey && LOGOUT_REDIRECT_URLS[redirectKey]) ||
    window.location.origin;

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout({
          logoutParams: { returnTo: redirectUrl, federated: true },
        });
      } catch (error) {
        console.error('Error during federated logout.', error);
        window.location.href = redirectUrl; //Redirect regardless
      }
    };

    void performLogout();
  }, [logout, redirectUrl]);

  return <Loader inProjectPage={false} fullScreen logo />;
};

export default Logout;
